import React, { useEffect } from 'react';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import useScript from '../Hooks/useScript';
import useStyleSheet from '../Hooks/useStyleSheet';
import { useDataFetcherV2 } from './Common/Data/useDataFetcher';
import {
  fetchOrganization,
  getDefaultIndustryName,
  getEmployeeCount,
} from '../Resources/Organization/OrganizationData';
import { fetchPro, getFullName, getEmail, getMobileNumber } from '../Resources/Pro/ProData';
import { isPresent } from 'utils/isPresent';
import { fetchCalendlyLink, getCalendlyLink } from './Setup/api/SetupData';

const CalendlyPopup = ({ onOpen, onDemoBooked, buttonText, location = '', ...buttonProps }) => {
  const [proFetched] = useDataFetcherV2(fetchPro);
  const [orgFetched] = useDataFetcherV2(fetchOrganization);
  const [calendlyLinkFetched] = useDataFetcherV2(fetchCalendlyLink);

  const proFullName = useSelector(getFullName);
  const proEmail = useSelector(getEmail);
  const proMobileNumber = useSelector(getMobileNumber);
  const industryName = useSelector(getDefaultIndustryName);
  const employeeCount = useSelector(getEmployeeCount);

  const calendlyLink = useSelector(getCalendlyLink);
  const [scriptLoaded] = useScript('calendly-script', 'https://assets.calendly.com/assets/external/widget.js');
  useStyleSheet('calendly-css', 'https://calendly.com/assets/external/widget.css');

  const dataFetched = () => proFetched && orgFetched && calendlyLinkFetched;
  const calendlyLoaded = () => scriptLoaded && isPresent(window.Calendly);

  useEffect(() => {
    const isCalendlyEvent = (event) => event && event.indexOf('calendly') === 0;
    const calendlyEventListener = ({ data: { event } }) => {
      if (isCalendlyEvent(event)) {
        if (event === 'calendly.event_scheduled') onDemoBooked();
        if (event === 'calendly.event_type_viewed') onOpen();
      }
    };
    window.addEventListener('message', calendlyEventListener);
    return () => window.removeEventListener('message', calendlyEventListener);
  }, []);

  if (!dataFetched() || !calendlyLoaded()) {
    return null;
  }

  const calendlyOptions = {
    url: calendlyLink,
    prefill: {
      name: proFullName,
      email: proEmail,
      customAnswers: {
        a1: `1${proMobileNumber}`,
        a2: employeeCount,
        a3: industryName,
      },
    },
  };

  return (
    <Button
      color="primary"
      onClick={() => {
        window.Calendly.initPopupWidget(calendlyOptions);
      }}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...buttonProps}
    >
      {buttonText}
    </Button>
  );
};

CalendlyPopup.propTypes = {
  onOpen: PropTypes.func.isRequired,
  onDemoBooked: PropTypes.func.isRequired,
  buttonText: PropTypes.string.isRequired,
};

export default CalendlyPopup;
